import { FC, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import carousel1 from "@/assets/images/v2/beforeAfter/carousel/carousel1.png";
import carousel2 from "@/assets/images/v2/beforeAfter/carousel/carousel2.png";
import carousel4 from "@/assets/images/v2/beforeAfter/carousel/carousel4.png";
import carousel5 from "@/assets/images/v2/beforeAfter/carousel/carousel5.png";
import carousel6 from "@/assets/images/v2/beforeAfter/carousel/carousel6.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";

type Slide = {
  icon: string;
  quote: string;
};

const slides: Slide[] = [
  {
    icon: carousel1,
    quote: `As someone who works in fashion, I was living a double life — styling clients all day
      while hiding in oversized clothes myself. The irony wasn't lost on me.
      SkinnyRx changed everything when nothing else worked.
      Now I'm not mentally calculating how to hide my body in every social situation.`,
  },
  {
    icon: carousel2,
    quote: `After my heart scare last year, my doctor didn't sugarcoat it — lose weight or else.
      I'd tried everything over the years but nothing stuck.
      SkinnyRx was different from day one.
      The constant hunger that followed me for decades just... vanished.`,
  },

  {
    icon: carousel4,
    quote: `Working in tech meant constant stress, late nights, and office snacks destroying my health.
      My dating profile pics were all from years ago because I couldn't stand recent ones.
      SkinnyRx broke the cycle when nothing else worked.
      I'm not hiding from the camera anymore or dreading Monday morning meetings.`,
  },
  {
    icon: carousel5,
    quote: `After my divorce, I let myself go completely. Takeout every night, beer on weekends, you know how it is.
      My doctor warned me about my blood pressure, but diets never stuck. SkinnyRx changed that overnight.
      Food just doesn't control my life anymore.`,
  },
  {
    icon: carousel6,
    quote: `I'd tried everything — counting every calorie, expensive meal services, even those awful 5 A.M. workout classes.
      Nothing worked until SkinnyRx. Now I can actually go out to dinner with friends without obsessing over
      the menu or feeling guilty afterwards. My doctor was shocked at my last checkup!`,
  },
];

const TestimonialsCarousel: FC = () => {
  const [current, setCurrent] = useState(0);
  const total = slides.length;

  const goPrev = () => setCurrent((i: number) => (i - 1 + total) % total);
  const goNext = () => setCurrent((i: number) => (i + 1) % total);

  return (
    <div className="w-full relative">
      <Carousel
        selectedItem={current}
        onChange={setCurrent}
        showThumbs={false}
        showStatus={false}
        infiniteLoop
        swipeable
        emulateTouch
        autoPlay={false}
        showArrows={false}
        className="relative z-10"
        renderIndicator={() => null}
      >
        {slides.map((s, i) => (
          <div key={i}>
            <figure className="relative">
              <img src={s.icon} alt={`Slide ${i + 1}`} />
            </figure>
            <blockquote className="mt-4 text-center text-base text-dark-purple-2 w-full">
              "{s.quote}"
            </blockquote>
          </div>
        ))}
      </Carousel>
      <div className="relative z-10 mt-4 flex items-center justify-center gap-12">
        <button
          onClick={goPrev}
          className="grid place-items-center h-8 w-8 rounded-full bg-purple10 text-white shadow hover:opacity-90"
        >
          <svg
            viewBox="0 0 24 24"
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              d="M15 18l-6-6 6-6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <div className="flex items-center gap-2">
          {Array.from({ length: total }).map((_, idx) => (
            <button
              key={idx}
              onClick={() => setCurrent(idx)}
              className={`h-2.5 w-2.5 rounded-full ${
                current === idx ? "bg-purple10" : "bg-purple10/50"
              }`}
            />
          ))}
        </div>
        <button
          onClick={goNext}
          className="grid place-items-center h-8 w-8 rounded-full bg-purple10 text-white hover:opacity-90"
        >
          <svg
            viewBox="0 0 24 24"
            className="h-5 w-5"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path
              d="M9 6l6 6-6 6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export { TestimonialsCarousel };
